import { combineReducers } from 'redux';
import { userReducer } from './user/Reducer';

export const rootReducer = combineReducers({ userReducer });
export type IReducer = ReturnType<typeof rootReducer>;
